import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { useState, type FC } from 'react'
import { createRoot } from 'react-dom/client'
import { Document, pdfjs, Page as PdfPage } from 'react-pdf'
import 'react-pdf/dist/Page/AnnotationLayer.css'
import 'react-pdf/dist/Page/TextLayer.css'
import { SiteLayout } from '~/components/layout/SiteLayout'
import { localStoragePersister as persister, queryClient } from '~/services/queryClient'
import { cm } from '~/utils/utils'
import { NextUIProvider } from '@nextui-org/react'

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url
).toString()

export const Page: FC = () => {
  const [numPages, setNumPages] = useState<number>(0)

  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages)
  }

  return (
    <SiteLayout className='privacy'>
      <div className='w-full h-full overflow-auto no-scrollbar mt-20'>
        <div className={cm('max-w-5xl m-auto mb-10', 'leading-6 flex-col')}>
          <Document
            file='documents/privacy-policy-v2.pdf'
            onLoadSuccess={onDocumentLoadSuccess}
            loading={null}
            className='mt-[-5rem]'
          >
            {Array.from(new Array(numPages), (_, index) => (
              <PdfPage
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                height={1200}
                loading={null}
              />
            ))}
          </Document>
        </div>
      </div>
    </SiteLayout>
  )
}

export default Page
